import type { ReactNode } from 'react';
import { Button, type ButtonProps } from '../Button';

export interface IconButtonProps extends Omit<ButtonProps, 'size' | 'children'> {
  /** The icon element to render (e.g. `<Pencil className="h-4 w-4" />`). */
  icon: ReactNode;
  /** Required — icon-only buttons must be labelled for screen readers. */
  'aria-label': string;
  /** Square size: `icon` (40px) or `icon-sm` (32px). */
  size?: 'icon' | 'icon-sm';
}

/**
 * Square, icon-only button. A thin wrapper over `Button` that enforces an `aria-label`
 * (icon-only controls are unlabelled otherwise) and defaults to the `ghost` variant.
 */
export function IconButton({
  icon,
  size = 'icon-sm',
  variant = 'ghost',
  ...props
}: IconButtonProps) {
  return (
    <Button data-slot="icon-button" size={size} variant={variant} {...props}>
      {icon}
    </Button>
  );
}
